module.exports = __webpack_public_path__ + "img/zzt-fp-en.2b5e56ba.png";